"use strict";

import { StyleSheet } from 'react-native';
export const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    pointerEvents: 'box-none'
  }
});
//# sourceMappingURL=styles.js.map